import g2eApi from '../../../api/hr/g2e'
import staffSettingApi from '@/api/hr/staffSetting'
import eLeaveApi from '../../../api/leave/eLeave'
import esignApi from '../../../api/esign/signing'
import appraiserApi from '@/api/hr/appraiser'
// import taskListApi from '../../../api/training/taskList'
// import CourseAppForm from '../../models/CourseAppForm'

// initial state
const state = {
  info: null,
  availableLeaveMark: [{
    staffCode: null,
    absentTypeId: null,
    absentTypeChinDesc: null,
    absentTypePortDesc: null,
    year: null,
    startDate: null,
    endDate: null,
    numDays: null,
    consumeStatusCode: null
  }],
  appraiser: null,
  numberOfSigningCartItem: 0,
  photoInBase64: null,
  defaultNextStaff: null
}

// getters
const getters = {
  getDefaultNextStaff: (state, getters) => {
    if (state.defaultNextStaff) {
      return state.defaultNextStaff.euid
    } else {
      return null
    }
  }
// getMotherLangId: (state, getters) => {
//   // console.log('getCourseById: ' + id)
//   for (let index = 0; index < state.info.languages.length; index++) {
//     if (state.info.languages[index].isMotherLang) {
//       return index
//     }
//   }
// }
// getMaskDocNum: (state) => {
//   if (!state.info.docNum) {
//     let first5Chars = state.info.docNum.slice(0, 5)
//     return first5Chars.padEnd(state.info.docNum.length, '*')
//   }
// }
}

// actions
const actions = {
  getStaff ({ commit }) {
    return new Promise((resolve, reject) => {
      appraiserApi.getAppraiser(resp => {
        commit('setAppraiser', resp)
      })
      g2eApi.getStaff(staff => {
        commit('setStaff', staff)
        resolve()
      })
    })
  },

  getAvailableLeaveMark ({ commit }, year) {
    eLeaveApi.getAvailableStaffLeaveMark(year, leaveMark => {
      commit('setAvailableLeaveMark', leaveMark)
    })
  },

  countSigningCartItem ({ commit }) {
    esignApi.countSigningCartItem(resp => {
      commit('setNumberOfSigningCartItem', resp)
    })
  },

  getStaffPhoto ({ commit }) {
    g2eApi.getStaffPhoto(cb => {
      commit('setStaffPhoto', cb)
    })
  },

  getStaffRoles ({ commit }) {
    return new Promise((resolve, reject) => {
      g2eApi.getStaffRoles(cb => {
        commit('setStaffRoles', cb)
        resolve()
      })
    })
  },

  loadDefaultNextStaff ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.defaultNextStaff) {
        staffSettingApi.getDefaultNextStaff(resp => {
          commit('setDefaultNextStaff', resp)
          resolve()
        })
      }
      resolve()
    })
  },

  refreshDefaultNextStaff ({ commit, state }) {
    return new Promise((resolve, reject) => {
      staffSettingApi.getDefaultNextStaff(resp => {
        commit('setDefaultNextStaff', resp)
        resolve()
      })
    })
  }

  // searchStaff ({ commit }, name) {
  //   g2eApi.searchStaff(appraiser => {
  //     commit('setAppraisers')
  //   }, name)
  // }
}

// mutations
const mutations = {
  setStaff (state, staff) {
    state.info = staff
  },

  setAvailableLeaveMark (state, leaveMark) {
    state.availableLeaveMark = leaveMark
  },

  setAppraiser (state, appraiser) {
    state.appraiser = appraiser
  },

  setNumberOfSigningCartItem (state, number) {
    state.numberOfSigningCartItem = number
  },

  setStaffPhoto (state, base64String) {
    state.photoInBase64 = 'data:image/jpeg;base64, ' + base64String
  },

  setStaffRoles (state, roles) {
    state.roles = roles
  },

  setDefaultNextStaff (state, resp) {
    if (resp.status === 201 || resp.status === 200) {
      let isGroup = null
      let euid = null
      if (resp.data) {
        isGroup = !resp.data.defaultNextEuid
        euid = resp.data.defaultNextEuid ? resp.data.defaultNextEuid : resp.data.defaultNextDefinedGroupId + ''
      }
      state.defaultNextStaff = { euid: euid, isGroup: isGroup }
    }
  }

  // initAppraiser (state) {
  //   state.appraiser[0].staffcode = state.info.inChargedBy
  //   state.appraiser[0].chinName = state.info.inChargedByChinName
  //   state.appraiser[0].portName = state.info.inChargedByPortName
  //   state.appraiser[0].nickName = state.info.inChargedByNickName
  // }

  // setCourseAppForm (state, courseAppForm) {
  //   state.courseAppForm = courseAppForm
  // }
//   setCourse (state, course) {
//     state.course = course
//   }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
